import dayjs from 'dayjs';

export const formatToHour = (date?: string) => {
    return date ? dayjs(date).format('HH:mm') : undefined;
};
